import React from "react";
import Arrow from "../../assets/svgImages/Arrow_Right.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LastTransaction = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
      // added display:none for v1
    <div className="last-transaction"  style={{display:"none"}}>
      <div className="last-transaction__content">
        <p>{t("Created at Roger")}</p>
        <h3>{t("See more works")}</h3>
      </div>
      <div
        className="last-transaction__svg"
        onClick={() => navigate("/tracks")}
      >
        <img src={Arrow} alt="" />
      </div>
    </div>
  );
};

export default LastTransaction;
